/* Nyxora v5 · image loading
   1. Lazy images far below the fold get a responsive srcset sized to their real
      layout width, so phones stop fetching 1200-1600px files.
   2. Lazy images start loading about two and a half screens before they scroll into view.
   3. They fade in once decoded instead of popping in.
   4. Key content images (product technical drawing) start loading right away.
   Images the browser may already be fetching are never re-pointed (no double download). */
(function () {
  var WIDTHS = [320, 480, 640, 800, 1000, 1200, 1600, 2000, 2400];
  var PRIORITY = '.nyx-v5-pdp__sheet-fig img';

  function shopifyWidth(src) {
    if (!src || src.indexOf('/cdn/shop/') === -1 && src.indexOf('cdn.shopify.com') === -1) return 0;
    var m = src.match(/[?&]width=(\d+)/);
    return m ? parseInt(m[1], 10) : 0;
  }

  function withWidth(src, w) {
    return src.replace(/([?&])width=\d+/, '$1width=' + w);
  }

  function upgrade(img) {
    if (img.dataset.nyxImg) return;
    img.dataset.nyxImg = '1';
    if ((img.getAttribute('loading') || '') !== 'lazy') return;
    if (img.currentSrc || img.complete) return;

    var src = img.getAttribute('src') || '';
    var max = shopifyWidth(src);
    var rect = img.getBoundingClientRect();
    var vw = window.innerWidth || 1200;
    var vh = window.innerHeight || 800;
    /* Within ~3000px the browser may already be fetching a lazy image: leave its src alone */
    var far = rect.top > vh + 3000 || rect.bottom < -3000 || rect.left > vw + 3000 || rect.right < -3000;
    if (max && far && !img.getAttribute('srcset')) {
      /* offsetWidth is the layout width, unaffected by reveal transforms */
      var shown = img.offsetWidth || Math.round(rect.width);
      if (shown > 0) {
        var set = [];
        for (var i = 0; i < WIDTHS.length; i++) {
          if (WIDTHS[i] < max) set.push(withWidth(src, WIDTHS[i]) + ' ' + WIDTHS[i] + 'w');
        }
        set.push(withWidth(src, max) + ' ' + max + 'w');
        img.setAttribute('sizes', shown + 'px');
        img.setAttribute('srcset', set.join(', '));
      }
    }

    if (getComputedStyle(img).opacity === '1' && !img.closest('[data-pdp-story-bg]')) {
      img.classList.add('nyx-img-fade');
      var reveal = function () { img.classList.add('is-in'); };
      img.addEventListener('load', reveal, { once: true });
      img.addEventListener('error', reveal, { once: true });
      if (img.complete) reveal();
    }

    if (warm) warm.observe(img);
  }

  var warm = 'IntersectionObserver' in window
    ? new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          e.target.loading = 'eager';
          warm.unobserve(e.target);
        });
      }, { rootMargin: '250% 100% 250% 100%' })
    : null;

  function scan() {
    var pri = document.querySelectorAll(PRIORITY);
    for (var p = 0; p < pri.length; p++) pri[p].loading = 'eager';
    var imgs = document.querySelectorAll('img[loading="lazy"]');
    for (var i = 0; i < imgs.length; i++) upgrade(imgs[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }
  /* Sections loaded later (theme editor, drawers, recommendations) */
  if ('MutationObserver' in window) {
    new MutationObserver(function (list) {
      for (var i = 0; i < list.length; i++) {
        var added = list[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var n = added[j];
          if (n.nodeType !== 1) continue;
          if (n.tagName === 'IMG' && n.getAttribute('loading') === 'lazy') upgrade(n);
          else if (n.querySelectorAll) {
            var inner = n.querySelectorAll('img[loading="lazy"]');
            for (var k = 0; k < inner.length; k++) upgrade(inner[k]);
          }
        }
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
})();